import React, { useState } from "react";
import Layout from "../../components/layout";
import BaseCheckbox from "../checkbox/BaseCheckbox";
import MatrixCheckbox from "../checkbox/MatrixCheckbox";
import BaseInput from "../input/BaseInput";
import MatrixInput from "../input/MatrixInput";
import Explain from "../input/Explain";
import BaseRadio from "../radio/BaseRadio";
import MatrixRadio from "../radio/MatrixRadio";
import Age from "../other/Age";
import City from "../other/City";
import Sex from "../other/Sex";

import "./index.less";

const componentList = [
  <BaseRadio />,
  <MatrixRadio />,
  <BaseCheckbox />,
  <MatrixCheckbox />,
  <Explain />,
  <BaseInput />,
  <MatrixInput />,
  <Age />,
  <City />,
  <Sex />,
];

// 静态问题展示页
export default function Answer(props) {
  const [index, setIndex] = useState(0);

  // 修改序号
  const changeIndex = (add) => {
    if (add === 0) {
      setIndex(add);
    } else {
      if (index + add < 0) {
        setIndex(0);
      } else if (index + add > componentList.length - 1) {
        setIndex(componentList.length - 1);
      } else {
        setIndex(index + add);
      }
    }
  };

  return <Layout changeChildren={changeIndex}>{componentList[index]}</Layout>;
}
